var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAioaHideIconType33(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 61,
    stroke: "white",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110 74.9987C110 78.3131 107.258 81 103.873 81H46.1236C44.4329 81 42.9019 80.3285 41.793 79.2423C40.685 78.1577 40 76.6576 40 75.0004C39.9991 71.6856 42.742 68.9991 46.1268 69H103.877C107.26 69.0007 109.999 71.6856 110 74.9987Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAioaHideIconType33);
export default __webpack_public_path__ + "static/media/aioa-hide-icon-type-33.5e04fa2a441be56c72a8bd4354f16c1d.svg";
export { ForwardRef as ReactComponent };